export function dataInRequest(params = {}) {
  return {
    type: '@perfis/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@perfis/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@perfis/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@perfis/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@perfis/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@perfis/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@perfis/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@perfis/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@perfis/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@perfis/RECORD_FILTERING',
    payload: { params },
  };
}
